<template lang="pug">
  .cardTitle.direct-flex
      .square.direct-flex-center(:style="`background: ${color}22`")
        vm-icon(:icon="icon" color="#A34936" v-if="isIcon")
        .number.space-grotesk(v-if="!isIcon") {{ number }}
      .text.space-grotesk  {{ text }}
</template>

<script>
export default {
  name: 'CardTitle',
  components: {
  },
  props: {
    icon: {
      type: String,
      default: ''
    },
    text: {
      default: 'Sample Title',
      type: String
    },
    color: {
      default: '#FF8200',
      type: String
    },
    number: {
      type: Number,
      default: 0
    },
    isIcon: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="scss" scoped>
.square {
  width: 25px;
  height: 25px;
  margin-right: 15px;
}
.number {
  color: var(--green)
}
.text {
  color: var(--green)
}
</style>
